import { render } from "./ShipmentOrder.vue?vue&type=template&id=744a4338"
import script from "./ShipmentOrder.vue?vue&type=script&lang=js"
export * from "./ShipmentOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__